import React from "react";
import { CheckCircle, ArrowLeft } from "lucide-react";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";

export default function PasswordResetConfirmation() {
  const navigate = useNavigate();

  return (
  <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", padding: "24px 16px", background: "var(--bg)", position: "relative" }}>
      {/* Back Button */}
      <button
        onClick={() => navigate("/signin")}
        className="btn position-absolute"
        style={{ top: "20px", left: "20px", color: "var(--primary)", borderRadius: "50%" }}
      >
        <ArrowLeft size={24} />
      </button>

      {/* Card */}
      <div style={{ width: "100%", maxWidth: "400px", borderRadius: "22px", background: "#fff", border: "1px solid #ececf5", boxShadow: "0 12px 36px rgba(80, 0, 200, 0.09)", padding: "32px 28px", textAlign: "center" }}>
        {/* Logo */}
        <div className="mb-4">
          <img src={logo} alt="Logo" style={{ width: "64px" }} />
        </div>

        {/* Success Icon */}
        <div className="d-flex justify-content-center align-items-center mb-4" style={{ width: "80px", height: "80px", borderRadius: "50%", margin: "0 auto", background: "color-mix(in srgb, var(--primary) 12%, white)" }}>
          <CheckCircle size={40} color="var(--primary)" />
        </div>

        {/* Text */}
        <h5 className="fw-semibold mt-3" style={{ color: "#171b2d", fontSize: "22px" }}>Check Your Email</h5>
        <p style={{ color: "#73798a", marginBottom: "1rem", fontSize: "0.9em", lineHeight: 1.5 }}>
          We’ve sent a password reset link to your registered email address.
          Please follow the link to create a new password.
        </p>

        {/* Back to Sign In */}
        <button onClick={() => navigate("/signin")} className="btn w-100 btn-accent" style={{ padding: "12px", borderRadius: "10px", fontWeight: "600" }}>
          Back to Sign In
        </button>
      </div>
    </div>
  );
}
